(function() {
'use strict';
  
  angular
    .module('app.myPolls')
    .controller('MyPollsController', MyPollsController);
      
  MyPollsController.$inject = [
    '$log', 
    '$mdDialog',
    '$mdSidenav',
    '$scope',
    '$state',
    '$window',
    'auth',
    'shell', 
    'settings',
    'myPollsService'
  ];
    
  function MyPollsController(
      $log,
      $mdDialog,
      $mdSidenav,
      $scope,
      $state,
      $window,
      auth, 
      shell, 
      settings, 
      myPollsService) {
    $log = $log.getInstance('MyPollsController');
    
    /* jshint validthis: true */
    var vm = this;
    vm.addCollection = addCollection;
    vm.collections = [];
    vm.editCollection = editCollection;
    vm.settings = settings;
    vm.unreadAnnouncementsCount = 0;
    activate();

    function activate() {
      auth.isAuthenticated().then(function(user) {
        if (user.group !== 'poller')
          return $state.go('shell.forbidden');

        shell.viewSync.ignoreStates([
          'shell.myPolls.collections.editPolls',
        ]);
        settings.get('shell.myPolls.isViewSynchronized', true)
          ? shell.viewSync.enable()
          : shell.viewSync.disable();

        shell.showSidebar(
          'app/my-polls/my-polls.sidebar.html', 
          vm, 
          { persist: 'shell.myPolls' });
        shell.setUserMenu([
            {
              label: 'Audience Mode',
              icon: 'weekend',
              callback: goToAudienceMode
            }
          ], { persist: 'shell.myPolls' });

        $scope.$on('communityNews.announcementsRead', updateUnreadAnnouncementsCount);

        shell.setAction('Loading');
        myPollsService.getCollections()
          .then(function(collections) {
            shell.clearAction();
            vm.collections = collections;
            if (collections.length === 0) {
              return $state.go('shell.myPolls.userGuide');
            }
          })
          .then(updateUnreadAnnouncementsCount);
      });
    }

    function addCollection() {
      $mdDialog.show({
        templateUrl: 'app/my-polls/shell/add-collection.html',
        clickOutsideToClose: true,
        controller: 'AddCollectionController as vm'
      }).then(function(collection) {
        $mdSidenav('left').toggle();
        $state.go('shell.myPolls.collections.viewCollection', { 
          collectionId: collection._id 
        });
      })
      // temp fix for https://github.com/angular/material/issues/10369
      .catch(angular.noop);
    }

    function editCollection (collection) {
      $mdDialog.show({
        templateUrl: 'app/my-polls/shell/edit-collection.html',
        controller: 'EditCollectionController as vm',
        clickOutsideToClose: true,
        locals: {collection: collection}
      })
      // temp fix for https://github.com/angular/material/issues/10369
      .catch(angular.noop);
    }
    
    function goToAudienceMode() {
      shell.viewSync.disable();
      $state.go('shell.poll');
    }

    function updateUnreadAnnouncementsCount() {
      return myPollsService.getUnreadAnnouncementsCount()
        .then(function(unreadAnnouncementsCount) {
          vm.unreadAnnouncementsCount = unreadAnnouncementsCount;
        });
    }
  }
  
})();